import {PureComponent} from "react"
import {SetAuthed} from "../AuthedChecker"

export interface SetAuthStatusProps {
  setAuthed: SetAuthed
  unauthed?: boolean
  noauth?: boolean
}

export default class SetAuthStatus extends PureComponent<SetAuthStatusProps> {
  static defaultProps = {
    unauthed: false,
    noauth: false
  }

  componentDidMount() {
    const {setAuthed, unauthed, noauth} = this.props
    setAuthed({authed: !unauthed, noauth})
  }

  render() {
    return null
  }
}
